const calculateTax = (value, reverse) => {
	const valueWithoutComma = typeof value === 'string' ? value.replace(',', '.') : value
	const floatValue = parseFloat(valueWithoutComma).toFixed(2)
	if (reverse) {
		return (floatValue / 1.19).toFixed(2)
	}
	return (floatValue * 1.19).toFixed(2)
}

export default calculateTax
